var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcReview = function SvgIcReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    fill: "none",
    viewBox: "0 0 11 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E64D3",
    stroke: "#0E64D3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.846,
    d: "M10.085 3.969a2.357 2.357 0 0 0-2.358-2.357H3.275A2.357 2.357 0 0 0 .918 3.969v3.179c0 .854.693 1.547 1.547 1.547.285 0 .515.23.515.515v.874c0 .199.232.308.386.181l1.688-1.391a.8.8 0 0 1 .5-.18h2.173a2.357 2.357 0 0 0 2.358-2.357z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.723,
    d: "M2.79 4.037h5.42M2.79 6.237h3.233"
  })));
};
export default SvgIcReview;